import { apiFetch } from "./apiClient";

export const placeOrder = async (orderData) => {
  console.log(orderData);
  return apiFetch("/place-order", {
    method: "POST",
    body: JSON.stringify(orderData),
  });
};


export const orderHistory = async () => {
  return apiFetch("/my-orders", {
    method: "GET",
  });
};